import React, { useContext, Fragment } from 'react';
import axios from './services/axios';
import { setFetchInstance } from './services/sFetch';

const t = (locales) => {
    return (literal, params = [], cb) => {
        let result = literal;

        if (locales && Object.prototype.hasOwnProperty.call(locales, literal)) {
            result = locales?.[literal]?.split('\\n').join('\n') || locales[literal];
        }

        if (
            locales &&
            literal &&
            !Object.prototype.hasOwnProperty.call(locales, literal) &&
            !params?.length
        ) {
            return literal;
        }

        if (params && params.length > 0 && result) {
            result = result.replace(/%([0-9]+)\$s/g, '%@');
            if (result.includes('%@')) {
                if (cb) {
                    const appearances = result.match(new RegExp('%@', 'g'));
                    let lastIndex = 0;
                    let resultParts = [];
                    appearances.forEach((app, index) => {
                        const currentIndex = result.indexOf('%@', lastIndex);
                        resultParts.push(result.slice(lastIndex, currentIndex));
                        resultParts.push(cb ? cb(params[index], index) : params[index]);
                        lastIndex = currentIndex + 2;
                    });
                    if (lastIndex < result.length) {
                        resultParts.push(result.slice(lastIndex, result.length));
                    }

                    return (
                        <Fragment>
                            {resultParts.map((part, index) => (
                                <Fragment key={index}>{part}</Fragment>
                            ))}
                        </Fragment>
                    );
                } else {
                    const appearances = result.match(new RegExp('%@', 'g')).length;
                    for (let i = 0; i < appearances && i < params.length; i += 1) {
                        result = result.replace('%@', params[i]);
                    }
                }
            }
        }

        return result;
    };
};

export const defaultContext = {
    isHorizontalResizeActive: false,
    setHorizontalResizeActive: () => {},
};
const Web5Context = React.createContext(defaultContext);

export function getContext(context) {
    let finalContext = {
        ...defaultContext,
        ...context,
    };

    if (finalContext.axiosInstance) axios.setInstance(finalContext.axiosInstance);
    else if (finalContext.token) axios.setData(finalContext.token, finalContext.apiBaseURL);

    if (finalContext.b2URL) axios.b2URL = finalContext.b2URL;
    if (finalContext.forceBIURL) axios.forceBIURL = finalContext.forceBIURL;
    if (finalContext.userTimezone) axios.userTimezone = finalContext.userTimezone;

    if (finalContext.fetchInstance) {
        setFetchInstance(finalContext.fetchInstance);
    }

    if (typeof finalContext.onUnauthorized === 'function') {
        axios.onUnauthorized = finalContext.onUnauthorized;
        if (!axios.unauthorizedHandlerInstalled) {
            axios.unauthorizedHandlerInstalled = true;
            axios.interceptors.response.use(
                (response) => response,
                (error) => {
                    if (error?.response?.status === 401) axios.onUnauthorized?.(error);
                    return Promise.reject(error);
                },
            );
        }
    }

    finalContext.getToken = () => {
        window.sessionStorage.getItem('fm_token');
    };
    finalContext.t = t(finalContext.locales);

    return finalContext;
}

export function useWeb5Context({ overrides = {} } = {}) {
    return { ...useContext(Web5Context), ...overrides };
}

export default Web5Context;
